import { createI18n } from 'vue-i18n'

import fi from './locales/fi.json'
import en from './locales/en.json'
import pl from './locales/pl.json'
import ru from './locales/ru.json'

const i18n = createI18n({
  fallbackLocale: 'en',
  messages: { fi, en, pl },
  missing: (locale, key) => {
    console.warn(`Missing translation for ${key} in ${locale}`)
    return key
  }
})

export default i18n
